/* Safe Kids Path — flashcard content. Replace this file in Shopify theme assets to update live content. */
window.SKP_CARD_DATA = [
  {
    "id": "sov-names-rule",
    "badge": "2",
    "title": "THE TRUE NAMES RULE",
    "subtitle": "We use the real words, no silly nicknames.",
    "ageGroup": "toddlers",
    "backBadge": "4",
    "backTitle": "THE REAL NAMES RULE",
    "backScript": "In our family, we use the REAL names for every part of our body. You have a nose, elbows, knees - and all your other parts have real names too. We don't use silly nicknames or secret code words. The real words aren't embarrassing or funny they're just words, like \"elbow\" is just a word. When we use real words, we can talk about anything.",
    "whyItMatters": "With correct vocabulary, children can communicate clearly if something ever happens. Using real words also signals to others that a child has been educated.",
    "commonMistake": "Only using nicknames or vague words like \"down there\" or \"bits.\" Children need actual vocabulary to speak up clearly.",
    "parentNote": "See your Quick-Start Guide for the complete list of age-appropriate terms to teach.",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/crd1_al1.webp?v=1781175672",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/cR1_back.webp?v=1781175823"
  },
  {
    "id": "sov-private-parts",
    "badge": "3",
    "title": "THE SWIMSUIT ZONE RULE",
    "subtitle": "Some parts of our body are private and that's important.",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "PRIVATE PARTS RULE",
    "backScript": "The parts of your body covered by a swimsuit are called your private parts. They're private because they're special and they belong only to you. Most people should never see or touch those parts. The only exceptions are: a doctor or nurse checking if you're healthy - but only when I'm right there with you.",
    "whyItMatters": "This gives children a clear, visual rule they can remember. \"What a swimsuit covers\" is concrete and easy to understand at any age.",
    "commonMistake": "Not explaining the doctor exception clearly. Add: \"And they should always tell you what they're doing and why - and I'll be there.\"",
    "parentNote": "No one should ask to see pictures of your private parts. And no one should show you pictures of theirs.",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C2_F.webp?v=1781178663",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C2_B.webp?v=1781178663"
  },
  {
    "id": "sov-no-means-no",
    "badge": "4",
    "title": "THE POWER TO SAY NO RULE",
    "subtitle": "You can say no to any touch, even hugs from the people you love.",
    "ageGroup": "school",
    "backBadge": "8",
    "backTitle": "THE NO MEANS NO RULE",
    "backScript": "If anyone wants to hug you, kiss you, tickle you, or touch you in ANY way - and you don't want them to - you can say \"No thank you.\" Even if it's grandma. Even if it's me! Your \"no\" matters. And if a grown-up gets upset when you say no to a hug? That's not your problem. Your body, your choice.",
    "whyItMatters": "Children who practice saying \"no\" to small things (hugs from relatives) are more likely to say \"no\" to big things. Consent starts with everyday moments.",
    "commonMistake": "Saying \"Just give grandma one hug\" or \"Don't be rude.\" This teaches kids their \"no\" can be overridden by adults.",
    "parentNote": "High-five, fist bump, wave, blow a kiss, or just saying \"Hi!\" - let them choose.",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C3_F.webp?v=1781178663",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C3_B.webp?v=1781178663"
  },
  {
    "id": "sov-tricky-touch",
    "badge": "5",
    "title": "THE CONFUSING TOUCH RULE",
    "subtitle": "Unsafe touch doesn't always feel bad, and that's confusing, but okay.",
    "ageGroup": "school",
    "backBadge": "7",
    "backTitle": "THE CONFUSING TOUCH RULE",
    "backScript": "Here's something important: unsafe touch doesn't always hurt. Sometimes it might feel ticklish, or warm, or even nice. That can be really confusing. But here's the rule: it's not about how it FEELS. It's about WHERE. If anyone touches your private parts - no matter how it feels - that's not okay. And it's never your fault for being confused.",
    "whyItMatters": "This is the #1 thing most parents miss. Predators don't use pain - they use confusion. Children who only know \"bad touch = hurts\" won't recognize abuse when it doesn't fit that definition.",
    "commonMistake": "Saying \"Tell me if anyone touches you in a way that feels bad.\" The child thinks: \"But it didn't feel bad... so maybe it's okay?\" Change \"feels bad\" to \"private parts.\"",
    "parentNote": "It's not about the feeling. It's about the location.",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C4_B.webp?v=1781178663",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C4_F.webp?v=1781178663"
  },
  {
    "id": "sov-no-bad-secrets",
    "badge": "6",
    "title": "THE NO BODY SECRETS RULE",
    "subtitle": "Surprises are fun. Body secrets are not allowed.",
    "ageGroup": "toddlers",
    "backBadge": "6",
    "backTitle": "THE NO BAD SECRETS RULE",
    "backScript": "Let's talk about secrets. SURPRISES are fun - like birthday presents. Everyone finds out eventually, and it makes people happy! But SECRETS are different. If anyone ever says \"Don't tell your mom\" or \"This is our secret\" about anything to do with bodies or touching - that's not a real secret. That's a TRICK. You tell me right away. Even if you promised. Even if it's someone you love. I will never be mad at YOU.",
    "whyItMatters": "This is the #1 tool predators use: \"This is our special secret.\" Children who know this rule don't stay silent.",
    "commonMistake": "Saying \"Don't keep secrets from me.\" Kids love secrets (whispered jokes, surprise parties). They get confused. Teach the difference: surprises = everyone finds out. Bad secrets = someone says NEVER tell.",
    "parentNote": "If a secret makes you feel icky inside, or someone says you can NEVER tell - that's a trick, not a secret.",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C5_F.webp?v=1781178663",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C5_B.webp?v=1781178662"
  },
  {
    "id": "sov-safety-circle",
    "badge": "7",
    "title": "THE TRUSTED TEAM RULE",
    "subtitle": "You have five safe grown-ups you can tell anything to.",
    "ageGroup": "school",
    "backBadge": "9",
    "backTitle": "THE SAFETY CIRCLE RULE",
    "backScript": "Let's make your Safety Circle. These are five grown-ups you can tell ANYTHING to - especially about body safety. Let's pick them together: two should be people who don't live with us. Who do you trust? And here's the most important part: if you tell one person and they don't believe you or don't help - you keep telling. Go to the next person. And the next. You keep telling until someone helps.",
    "whyItMatters": "Children need specific NAMES in their head not vague \"tell a grown-up.\" Under stress, kids freeze. A memorized list of 5 real people gives them a plan.",
    "commonMistake": "Only listing parents. What if the problem is IN the home? At least 2 adults must be outside the household (teacher, aunt, coach, neighbor).",
    "parentNote": "Have your child draw or write the 5 names. Practice saying them: \"I would tell _____, _____, or _____.\" If someone doesn't believe you, keep telling until someone does. Never stop.",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C6_F.webp?v=1781178663",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C6_B.webp?v=1781178663"
  },
  {
    "id": "body-autonomy",
    "badge": "1",
    "title": "coach",
    "subtitle": "I choose how to greet friends and family.",
    "ageGroup": "infants",
    "backBadge": "1",
    "backTitle": "BODY AUTONOMY",
    "backScript": "In our house, your body belongs to you. You are the boss of your body! If you or anyone else doesn't want a hug or a kiss, that is always okay.",
    "whyItMatters": "Instilling body autonomy early helps children build confidence, define healthy boundaries, and understand they have full rights over their physical self.",
    "commonMistake": "Forcing cosy physical contact like hugs or kisses with friends or relatives to be polite, which overrides their consent development.",
    "parentNote": "Encourage fun, polite alternatives like waving, high-fives, elbow bumps, or blowing kisses if your child expresses discomfort with hugs.",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93b.webp?v=1781181409"
  },
  {
    "id": "real-names",
    "badge": "2",
    "title": "REAL NAMES RULE",
    "subtitle": "We use the real words, no silly nicknames.",
    "ageGroup": "toddlers",
    "backBadge": "2",
    "backTitle": "REAL NAMES RULE",
    "backScript": "Use real, correct anatomical words for every part of your body. No baby-talk or silly nicknames. This keeps your communication clear and trusted.",
    "whyItMatters": "Using accurate anatomical words reduces shame and empowers children to report any boundary concern immediately with clear, unmistakable terms.",
    "commonMistake": "Using cute nicknames or euphemisms which can confuse young children and create a feeling that anatomical areas are secret or unspeakable.",
    "parentNote": "Normalize natural body talks during simple tasks like bath time, dressing up, or doctor visits with an objective, matter-of-fact tone.",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/card1_front.webp",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/card1_back.webp"
  },
  {
    "id": "safe-touch",
    "badge": "3",
    "title": "THE SAFE TOUCH",
    "subtitle": "My private parts are private.",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "THE SAFE TOUCH",
    "backScript": "Parts of your body covered by a bathing suit are private. No one should see or touch them, and you should never see or touch anyone else's private parts.",
    "whyItMatters": "Direct bathing-suit boundary rules are highly memorable and actionable, preventing confusion around inappropriate actions.",
    "commonMistake": "Describing private boundaries using complex descriptions or cute terms like \"special spots\" rather than direct anatomical descriptors.",
    "parentNote": "Explain that doctors, nurses, or trusted parents can touch to keep them clean or healthy, always explaining why first and confirming okay.",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/card2_front.webp",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/card2_back.webp"
  },
  {
    "id": "secrets-surprises",
    "badge": "5",
    "title": "SECRETS VS SURPRISES",
    "subtitle": "Surprises have an end date, but secrets last.",
    "ageGroup": "toddlers",
    "backBadge": "5",
    "backTitle": "SECRETS VS SURPRISES",
    "backScript": "A surprise is something happy that everyone gets to find out about very soon—like a gift! A secret is something that makes you feel bad or heavy and is meant to stay hidden.",
    "whyItMatters": "Grooming often relies on secret-keeping. Drawing a clear line between temporary surprises and heavy secrets removes a blocker for reports.",
    "commonMistake": "Accidentally using the word \"secret\" for happy surprises, which blurs the distinction and makes secret-keeping feel exciting or acceptable.",
    "parentNote": "Encourage an open family rule: \"We don't keep secrets in our family. We only have happy surprises that we share together.\"",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/card5_front.webp",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/card5_back.webp"
  },
  {
    "id": "listen-intuition",
    "badge": "6",
    "title": "doc room 2",
    "subtitle": "If something feels weird, it's an Uh-Oh sign.",
    "ageGroup": "toddlers",
    "backBadge": "6",
    "backTitle": "LISTEN TO YOUR TUMMY",
    "backScript": "If you ever get an \"Uh-Oh\" feeling in your tummy, your heart beats fast, or you feel sticky or scared, that is your intuition superpower! Pay attention to it.",
    "whyItMatters": "Children often want to please adults, even when they feel uncomfortable. Validating their physical intuition gives them permission to prioritize safety.",
    "commonMistake": "Dismissing children's persistent discomfort with certain adults or situations as \"oversensitivity\" or \"shyness.\"",
    "parentNote": "Always believe and praise your child when they share a feeling of discomfort: \"Thank you for telling me. I am glad you listened to your tummy.\"",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96B.webp?v=1781181408"
  },
  {
    "id": "respect-space",
    "badge": "9",
    "title": "playgorund 1",
    "subtitle": "Other people's bodies belong to them, too.",
    "ageGroup": "infants",
    "backBadge": "9",
    "backTitle": "RESPECT FOR SPACE",
    "backScript": "Just like you are the boss of your own body, your classmates and friends are the bosses of theirs! Always ask before hugging, ticking, or touching.",
    "whyItMatters": "Teaching kids to respect other children's boundaries builds empathy and naturally reinforces their understanding of their own body autonomy rights.",
    "commonMistake": "Encouraging children to touch others without permission to show affection, or ignoring a sibling saying \"Stop!\" during tickling.",
    "parentNote": "Actively enforce boundary actions: if a sibling says \"no\" or \"stop tickling,\" redirect immediately so they see that \"stop\" means \"stop.\"",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93b.webp?v=1781181409"
  },
  {
    "id": "digital-privacy",
    "badge": "11",
    "title": "lighlap",
    "subtitle": "What we see or chat online is never a secret.",
    "ageGroup": "school",
    "backBadge": "11",
    "backTitle": "SCREEN BOUNDARIES",
    "backScript": "If you see an image that makes you feel weird, a chat pop-up, or someone asking for photos, close the screen and tell me. You will never be in trouble!",
    "whyItMatters": "The digital space is a major gateway for early boundary crossings. A \"no online secrets\" rule ensures transparent screen usage.",
    "commonMistake": "Reacting with anger or taking away screens when a child sees something inappropriate, which guarantees they won't report next time.",
    "parentNote": "Praise honest screen reports: \"I am so glad you closed that app and showed me. It is not your fault, and you did the perfect thing.\"",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C94.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C94B.webp?v=1781181408"
  },
  {
    "id": "safe-haven",
    "badge": "13",
    "title": "ligtplay3",
    "subtitle": "A quiet place to relax when the world is too loud.",
    "ageGroup": "infants",
    "backBadge": "13",
    "backTitle": "THE SAFE HAVEN",
    "backScript": "When sensations, loud noises, or group situations become overwhelming, you can take a break in your clean safe-haven space.",
    "whyItMatters": "Overwhelmed children are more vulnerable to compliance or coercion. Recognizing when they need to retreat keeps their minds safe.",
    "commonMistake": "Treating a child's need for quiet or solo-time as bad behavior, rebellion, or anti-social acting.",
    "parentNote": "Help them organize a cozy spot with pillows and storybooks. Say: \"This is your quiet island. You can come here anytime to recharge.\"",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93b.webp?v=1781181409"
  },
  {
    "id": "boss-voice",
    "badge": "14",
    "title": "docroom2",
    "subtitle": "You can say NO to an adult if they cross boundaries.",
    "ageGroup": "toddlers",
    "backBadge": "14",
    "backTitle": "MY STRONG \"NO\" VOICE",
    "backScript": "If anyone—even a teacher, counselor, or family member—does something that makes you uncomfortable, you have full permission to yell \"NO!\" or \"STOP!\"",
    "whyItMatters": "Politeness training often backfires, forcing kids to suffer inappropriate behaviors in quiet distress because they are afraid to sound rude.",
    "commonMistake": "Disciplining young kids for being loud, assertive, or firm when talking back to adults about physical boundaries.",
    "parentNote": "Practice together in the car or park: \"Show me your loud, bossy voice! Say 'STOP IT, I don't like that!' louder! Excellent.\"",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96B.webp?v=1781181408"
  },
  {
    "id": "photo-boundaries",
    "badge": "16",
    "title": "homeway",
    "subtitle": "We do not take or keep secret body pictures.",
    "ageGroup": "school",
    "backBadge": "16",
    "backTitle": "PHOTO BOUNDARIES",
    "backScript": "Nobody should ever take pictures of your private parts, and you should never take photos of theirs. Photos are not for keeping secrets.",
    "whyItMatters": "Mitigates digital exploitation and peer boundaries. Establishes that the bathing-suit rule applies directly to photo sensors.",
    "commonMistake": "Sparing children this conversation due to awkwardness, which leaves them vulnerable to digital groomers or online games.",
    "parentNote": "Explain calmly: \"Pictures of your body are only for you and your doctors. If anyone asks for one, say no and let me know immediately.\"",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C95.webp?v=1781181409",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C95B.webp?v=1781181408"
  },
  {
    "id": "emotions-signals",
    "badge": "18",
    "title": "doctor room",
    "subtitle": "Anger, fear, and sadness are normal feel signals.",
    "ageGroup": "school",
    "backBadge": "18",
    "backTitle": "EMOTION SIGNALS",
    "backScript": "Emotions are warning lamps on a dashboard. If you feel scared or angry, it is a signal that a boundary has been crossed or something needs talk.",
    "whyItMatters": "Emotional suppression makes children easier to control. Validating all feelings enables children to alert you when something feels wrong.",
    "commonMistake": "Telling crying or frustrated children to \"stop crying\" or to \"be happy and polite,\" which signals that their warning lamps are invalid.",
    "parentNote": "Connect feelings with body reactions: \"Where do you feel anger? Is it in your tight fists? Or your throat? It's okay to feel it.\"",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96B.webp?v=1781181408"
  },
  {
    "id": "no-body-secrets",
    "badge": "20",
    "title": "nocar",
    "subtitle": "Secrets about bodies are never allowed.",
    "ageGroup": "school",
    "backBadge": "20",
    "backTitle": "NO BODY SECRETS",
    "backScript": "No one is allowed to touch your body, show you photos, or take pictures of you, and tell you to keep it a secret. You must always tell a parent immediately.",
    "whyItMatters": "The single most direct protection against abusive grooming. Breaks the cycle of shame, fear, and silence used by exploiters.",
    "commonMistake": "Assuming this is too serious for children. Clear boundaries expressed warmly provide ultimate mental security.",
    "parentNote": "Reinforce the absolute reporting guarantee: \"No matter what someone said would happen, you will never, ever be in trouble for telling me.\"",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C95.webp?v=1781181409",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C95B.webp?v=1781181408"
  },
  {
    "id": "card-1782872727810",
    "badge": "31",
    "title": "No force favors",
    "subtitle": "",
    "ageGroup": "toddlers",
    "backBadge": "32",
    "backTitle": "NEW CARD",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__1F_f8ba3606-7824-4e28-bae5-45f9d2a9a29a.png?v=1783314836",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__1B_1bc74b7c-76e9-4d4e-af38-e71136e0630a.png?v=1783314836"
  },
  {
    "id": "brave-boundary-2",
    "badge": "2",
    "title": "Brave Boundary 2",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "2",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__2F.png?v=1783314837",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__2B.png?v=1783314837"
  },
  {
    "id": "brave-boundary-3",
    "badge": "3",
    "title": "Brave Boundary 3",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__3F.png?v=1783314836",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__3B.png?v=1783314836"
  },
  {
    "id": "brave-boundary-4",
    "badge": "4",
    "title": "Brave Boundary 4",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "4",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__4F.png?v=1783314836",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__4B.png?v=1783314837"
  },
  {
    "id": "brave-boundary-5",
    "badge": "5",
    "title": "Brave Boundary 5",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "5",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__5F.png?v=1783314836",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__5B.png?v=1783314836"
  },
  {
    "id": "brave-boundary-6",
    "badge": "6",
    "title": "Brave Boundary 6",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "6",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__6F.png?v=1783314837",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__6B.png?v=1783314836"
  },
  {
    "id": "brave-boundary-7",
    "badge": "7",
    "title": "Brave Boundary 7",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "7",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__7F.png?v=1783314837",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__7B.png?v=1783314836"
  },
  {
    "id": "brave-boundary-8",
    "badge": "8",
    "title": "Brave Boundary 8",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "8",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__8F.png?v=1783314837",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JUNE_UPDATE_CARDS__8B.png?v=1783314836"
  },
  {
    "id": "trust-grid-1",
    "badge": "1",
    "title": "Trust Grid 1",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "1",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C91.webp?v=1781181409",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C91B.webp?v=1781181408"
  },
  {
    "id": "trust-grid-2",
    "badge": "2",
    "title": "Trust Grid 2",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "2",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C92.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C92B.webp?v=1781181408"
  },
  {
    "id": "trust-grid-3",
    "badge": "3",
    "title": "Trust Grid 3",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C93b.webp?v=1781181409"
  },
  {
    "id": "trust-grid-4",
    "badge": "4",
    "title": "Trust Grid 4",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "4",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C94.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C94B.webp?v=1781181408"
  },
  {
    "id": "trust-grid-5",
    "badge": "5",
    "title": "Trust Grid 5",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "5",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C95.webp?v=1781181409",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C95B.webp?v=1781181408"
  },
  {
    "id": "trust-grid-6",
    "badge": "6",
    "title": "Trust Grid 6",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "6",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/C96B.webp?v=1781181408"
  },
  {
    "id": "trust-grid-7",
    "badge": "7",
    "title": "Trust Grid 7",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "7",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "teal",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/MOVIE_F.webp?v=1781181408",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/MOVIE_b.webp?v=1781181408"
  },
  {
    "id": "public-smart-1",
    "badge": "1",
    "title": "Public & Street Smart 1",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "1",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/3debs.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/3debs_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-2",
    "badge": "2",
    "title": "Public & Street Smart 2",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "2",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/bday_baloons.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/bday_baloons_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-3",
    "badge": "3",
    "title": "Public & Street Smart 3",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/colorplay.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/colorplay_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-4",
    "badge": "4",
    "title": "Public & Street Smart 4",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "4",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/old_chair.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/old_chair_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-5",
    "badge": "5",
    "title": "Public & Street Smart 5",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "5",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/old_chair_door.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/old_chair_door_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-6",
    "badge": "6",
    "title": "Public & Street Smart 6",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "6",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/phone_table.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/phone_table_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-7",
    "badge": "7",
    "title": "Public & Street Smart 7",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "7",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/tabs.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/tabs_B.webp?v=1781185297"
  },
  {
    "id": "public-smart-8",
    "badge": "8",
    "title": "Public & Street Smart 8",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "8",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "yellow",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/tickle_baby.webp?v=1781185297",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/tickle_baby_B.webp?v=1781185297"
  },
  {
    "id": "digital-1",
    "badge": "1",
    "title": "Smart Tech 1",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "1",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_1_F.webp?v=1781193657",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_1.webp?v=1781193657"
  },
  {
    "id": "digital-2",
    "badge": "2",
    "title": "Smart Tech 2",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "2",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_2F.webp?v=1781193657",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_2.webp?v=1781193657"
  },
  {
    "id": "digital-3",
    "badge": "3",
    "title": "Smart Tech 3",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_3F.webp?v=1781193657",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_3.webp?v=1781193657"
  },
  {
    "id": "digital-4",
    "badge": "4",
    "title": "Smart Tech 4",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "4",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_4F.webp?v=1781193657",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL_4.webp?v=1781193657"
  },
  {
    "id": "digital-5",
    "badge": "5",
    "title": "Smart Tech 5",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "5",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL5F.webp?v=1781193657",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL5.webp?v=1781193657"
  },
  {
    "id": "digital-6",
    "badge": "6",
    "title": "Smart Tech 6",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "6",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "blue",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL6F.webp?v=1781193657",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/AL6.webp?v=1781193657"
  },
  {
    "id": "july-drop-1",
    "badge": "1",
    "title": "New Card 1",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "1",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__1F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__1B.png?v=1786359275"
  },
  {
    "id": "july-drop-2",
    "badge": "2",
    "title": "New Card 2",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "2",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__2F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__2B.png?v=1786359275"
  },
  {
    "id": "july-drop-3",
    "badge": "3",
    "title": "New Card 3",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "3",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__3F.png?v=1786359276",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS_3B.png?v=1786359275"
  },
  {
    "id": "july-drop-4",
    "badge": "4",
    "title": "New Card 4",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "4",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__4F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS_4B.png?v=1786359275"
  },
  {
    "id": "july-drop-5",
    "badge": "5",
    "title": "New Card 5",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "5",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__5F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS_5B.png?v=1786359275"
  },
  {
    "id": "july-drop-6",
    "badge": "6",
    "title": "New Card 6",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "6",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__6F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS_6B.png?v=1786359275"
  },
  {
    "id": "july-drop-7",
    "badge": "7",
    "title": "New Card 7",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "7",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__7F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS_7B.png?v=1786359275"
  },
  {
    "id": "july-drop-8",
    "badge": "8",
    "title": "New Card 8",
    "subtitle": "",
    "ageGroup": "school",
    "backBadge": "8",
    "backTitle": "",
    "backScript": "",
    "whyItMatters": "",
    "commonMistake": "",
    "parentNote": "",
    "themeColor": "orange",
    "frontImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS__8F.png?v=1786359275",
    "backImageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/JULY-UPDATE_CARDS_8B.png?v=1786359275"
  }
];
window.SKP_ALBUM_DATA = [
  {
    "id": "new-arrivals",
    "name": "New This Month",
    "description": "",
    "themeColor": "orange",
    "emoji": "✨",
    "cardIds": [
      "july-drop-1",
      "july-drop-2",
      "july-drop-3",
      "july-drop-4",
      "july-drop-5",
      "july-drop-6",
      "july-drop-7",
      "july-drop-8"
    ],
    "imageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/1989915e-1060-483f-97ed-ee8aa5058833.jpg?v=1786357963",
    "isNew": true
  },
  {
    "id": "brave-boundary-deck",
    "name": "The Brave Boundary Deck",
    "description": "",
    "themeColor": "blue",
    "emoji": "🌟",
    "cardIds": [
      "card-1782872727810",
      "brave-boundary-2",
      "brave-boundary-3",
      "brave-boundary-4",
      "brave-boundary-5",
      "brave-boundary-6",
      "brave-boundary-7",
      "brave-boundary-8"
    ],
    "imageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/Gemini_Generated_Image_r7ewohr7ewohr7ew.png?v=1783318048"
  },
  {
    "id": "sovereignty",
    "name": "Body Sovereignty",
    "description": "Empower kids with body ownership, greeting choices, personal space, and strong boundary voices.",
    "themeColor": "orange",
    "emoji": "🌸",
    "cardIds": [
      "sov-names-rule",
      "sov-private-parts",
      "sov-no-means-no",
      "sov-tricky-touch",
      "sov-no-bad-secrets",
      "sov-safety-circle"
    ],
    "imageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/s3.png?v=1782871103"
  },
  {
    "id": "digital",
    "name": "Smart Tech & Online Safety",
    "description": "Master healthy screen limits, password privacy, online friend safety, photo permissions, and kind digital words.",
    "themeColor": "blue",
    "emoji": "📱",
    "cardIds": [
      "digital-1",
      "digital-2",
      "digital-3",
      "digital-4",
      "digital-5",
      "digital-6"
    ],
    "imageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/S1.png?v=1782871103"
  },
  {
    "id": "public-smart",
    "name": "Public & Street Smart",
    "description": "Key skills for staying together, asking permission before trips, checking first, and freeze rules.",
    "themeColor": "yellow",
    "emoji": "🦁",
    "cardIds": [
      "public-smart-1",
      "public-smart-2",
      "public-smart-3",
      "public-smart-4",
      "public-smart-5",
      "public-smart-6",
      "public-smart-7",
      "public-smart-8"
    ],
    "imageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/s4.png?v=1782871103"
  },
  {
    "id": "trust-network",
    "name": "My Trust Grid",
    "description": "Define who to trust, spot tricky adults, create security passwords, and find community helpers.",
    "themeColor": "teal",
    "emoji": "🤝",
    "cardIds": [
      "trust-grid-1",
      "trust-grid-2",
      "trust-grid-3",
      "trust-grid-4",
      "trust-grid-5",
      "trust-grid-6",
      "trust-grid-7"
    ],
    "imageUrl": "https://cdn.shopify.com/s/files/1/0681/5979/9407/files/s2.png?v=1782871103"
  }
];